module.exports = __webpack_public_path__ + "static/media/Oddish_gaussian2.a615c277.png";